var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColdMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 1608,
    height: 612,
    x: 282,
    y: 141,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "100.1%",
    height: "100.7%",
    x: "-.1%",
    y: "-.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "Sourcefade",
    radius: 2.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "Sourcefade",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.704031571 0 0 0 0 0.685494773 0 0 0 0 0.796715561 0 0 0 0.633604677 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECEBEF",
    d: "M-976-350H944V730H-976z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-976 -350)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1607,
    height: 611,
    x: 282.5,
    y: 141.5,
    fill: "#FEFEFE",
    stroke: "#EBEBEB",
    strokeLinejoin: "square",
    rx: 4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#D5D2D5",
    d: "M-678.5-125.5V382a3.5 3.5 0 0 0 3.5 3.5H895a3.5 3.5 0 0 0 3.5-3.5v-507.5h-1577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#D5D2D5",
    d: "M246.5 34v-137a3.5 3.5 0 0 0-3.5-3.5H-24a3.5 3.5 0 0 0-3.5 3.5V34a3.5 3.5 0 0 0 3.5 3.5h267a3.5 3.5 0 0 0 3.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D5D2D5",
    d: "M26.5 27.5v-34h-22c-9.389 0-17 7.611-17 17s7.611 17 17 17h22z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#35A8E0",
    strokeLinecap: "round",
    strokeWidth: 1.026
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.035 1.439V21.25M12.949 3.674l-2.914 1.78-2.913-1.78M7.122 19.177l2.912-1.78 2.915 1.78M18.583 6.34L1.488 16.35M18.127 9.982l-3.009-1.614.063-3.414M1.804 12.789l3.009 1.615-.064 3.413M1.44 6.422l17.12 9.968M4.837 5.028l.073 3.414-3.006 1.622M15.302 17.865l-.072-3.413 3.005-1.623"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdMode);
export default __webpack_public_path__ + "static/media/coldMode.79c5d1ee8e2a12012e755d7db894e63d.svg";
export { ForwardRef as ReactComponent };